import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'bioconnect-ui-restricted-access',
  templateUrl: './restricted-access.component.html',
})
export class RestrictedAccessComponent {}
